// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2LOzR","search":"Settings_search__20z4C","filter":"Settings_filter__2pBQ8"};